import {alpha, Button, Dialog, DialogContent, IconButton, paperClasses, styled, Typography} from '@mui/material';
import {useEffect, useState} from 'react';

import {localStorageKey} from 'core/constants';
import {dayjs} from 'utils/dateUtils';
import BackgroundImage from 'core/images/other/notificationDialogBackground.png';
import {isCypressApp} from 'core/utils/cypress';

import CloseIcon from 'components/icons/cross.svg';

const SDialog = styled(Dialog)(() => ({
  [`.${paperClasses.root}`]: {
    background: `url(${BackgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
}));

const SHeader = styled('div')(({theme}) => ({
  display: 'flex',
  justifyContent: 'end',
  padding: theme.spacing(4),
}));

const SIconButton = styled(IconButton)(({theme}) => ({
  color: theme.palette.common.white,
}));

const SDialogContent = styled(DialogContent)(({theme}) => ({
  '&&': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(10),
    border: 'none',
    padding: theme.spacing(1, 6, 16),
  },
}));

const STypography = styled(Typography)(({theme}) => ({
  ...theme.typography.h3,
  letterSpacing: 0.15,
  lineHeight: '40px',
  fontWeight: 400,
  color: theme.palette.common.white,
}));

const STypographyBold = styled(STypography)(() => ({
  fontWeight: 700,
})) as typeof Typography;

const SButton = styled(Button)(({theme}) => ({
  background: theme.palette.logo.secondary,
  color: theme.palette.common.white,

  '&:hover': {
    background: alpha(theme.palette.logo.secondary, 0.8),
  },
})) as typeof Button;

const startDate = dayjs.tz('2025-11-03 09:00', 'America/New_York').utc();
const endDate = dayjs.tz('2025-11-06 14:00', 'America/New_York').utc();

const getDataFromLocalStorage = () => {
  const lsData = localStorage.getItem(localStorageKey.NotificationDialog);
  return lsData ? JSON.parse(lsData) : {isShown: false};
};

export const NotificationDialog = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const data = getDataFromLocalStorage();
    const now = dayjs.utc();
    const calculatedStartDate = data?.customStartDate
      ? dayjs.tz(data.customStartDate, 'America/New_York').utc()
      : startDate;
    const calculatedEndDate = data?.customEndDate ? dayjs.tz(data.customEndDate, 'America/New_York').utc() : endDate;
    const isWithinDateRange = now.isAfter(calculatedStartDate) && now.isBefore(calculatedEndDate);

    if (isWithinDateRange && !data?.isShown) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
    localStorage.setItem(
      localStorageKey.NotificationDialog,
      JSON.stringify({...getDataFromLocalStorage(), isShown: true})
    );
  };

  if (isCypressApp()) {
    return null;
  }

  return (
    <SDialog open={open} title='' onClose={handleClose}>
      <SHeader>
        <SIconButton size='small' onClick={handleClose}>
          <CloseIcon width={20} height={20} />
        </SIconButton>
      </SHeader>

      <SDialogContent>
        <STypography textAlign='center'>
          Join us on <STypographyBold component='span'>November 6, 2025 at 2 PM EST</STypographyBold> for a Product
          Overview of ennabl Docs!
        </STypography>

        <SButton
          variant='contained'
          target='_blank'
          href='https://cs0zu.share.hsforms.com/2uAHv9X0HRFCnm4SX-vYPMw?utm_medium=email&_hsenc=p2ANqtz--FaLZiQHxoxUj0iCddCPX8cMV310_tSblB4anD8C4g1VJVWRw7KHcToN-EH_c0yraTpmRHHl0bezmk99po6ixnGb9V5Q&_hsmi=2&utm_content=2&utm_source=hs_email'
        >
          Register Here
        </SButton>
      </SDialogContent>
    </SDialog>
  );
};
